const Style = {

  blankslate: 'absolute left-1/2 top-1/2 width-[80%] text-center -translate-x-1/2 -translate-y-1/2 md:w-96',
  title: `relative m-0 mb-5 font-semibold text-lg 
    after:absolute after:-bottom-2 after:left-1/2 after:w-5 
    after:h-px after:bg-slate-200 after:-translate-x-1/2`,

}

export default Style;